import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import PriceChecker from '../PriceChecker';
import TopbarStepper from './components/TopbarStepper';

import { TEST_ID_TOPBAR_OPEN_SUMMARY_BTN } from './constants';
import type { Step } from './types';
import { pushTopBarOpened } from './analitics';
import styles from './topbar.module.css';

type Props = {
  currentStep: string;
  steps: Step[];
  onClickStep: (newStep: string) => void;
  onOpenSummary: () => void;
};

const Topbar = (props: Props) => {
  const { currentStep, steps, onClickStep, onOpenSummary } = props;

  const { t } = useTranslation();

  const onClick = () => {
    onOpenSummary();
    pushTopBarOpened();
  };

  const showPriceInfo = currentStep !== steps[0]?.id;

  return (
    <div className={styles.container}>
      <TopbarStepper
        className={styles.element}
        currentStep={currentStep}
        onClickStep={onClickStep}
        steps={steps}
      />
      {showPriceInfo && (
        <div className={cn(styles.element, styles.priceInfo)}>
          <PriceChecker />
          <button
            className={styles.summaryButton}
            type="button"
            onClick={onClick}
            data-testid={TEST_ID_TOPBAR_OPEN_SUMMARY_BTN}
          >
            <p className={styles.text}>{t('checkout.billInfo.orderInfo')}</p>
          </button>
        </div>
      )}
    </div>
  );
};

export default Topbar;
